import { ContentBlocks } from "eddev/blocks"
import { defineView } from "eddev/views"

export const meta: ViewMeta = {
  templateName: "Holding Page",
}

export default defineView("template-holding-page", (props) => {
  return <ContentBlocks blocks={props.page?.contentBlocks} />
})
